const codes = (list: string): readonly string[] => list.trim().split(/\s+/);

const FALLBACK_VALUES: Record<string, Record<string, readonly string[]>> = {
  applovin: {
    campaignObjective: ['app_promotion'],
    optimizationGoal: ['AD_ROAS', 'BLD_ROAS', 'CPE', 'CPI'],
    platformBreakdown: ['AppLovin'],
    country: codes('au ca ch de fr gb nz us'),
  },
  dv360: {
    campaignObjective: ['brand_awareness', 'conversions'],
    optimizationGoal: [
      'BRAND_AWARENESS',
      'CONVERSION',
      'CPCV, ACR',
      'CPLPA',
      'KPI_TYPE_CLICK_CVR',
      'KPI_TYPE_CPA',
      'KPI_TYPE_CPCV',
      'KPI_TYPE_CPM',
      'KPI_TYPE_CPV',
      'KPI_TYPE_CTR',
      'KPI_TYPE_MAXIMIZE_PACING',
      'KPI_TYPE_OTHER',
      'KPI_TYPE_VIDEO_COMPLETION_RATE',
      'NO_OBJECTIVE',
      'ROAS',
      'Website visits',
    ],
    platformBreakdown: [],
    country: [],
  },
  google: {
    campaignObjective: ['app_promotion', 'brand_awareness', 'engagement', 'video_views'],
    optimizationGoal: [
      'OPTIMIZE_FOR_CLICKS',
      'OPTIMIZE_FOR_CONVERSIONS',
      'OPTIMIZE_FOR_IMPRESSIONS',
      'OPTIMIZE_FOR_REVENUE',
      'OPTIMIZE_INSTALLS_TARGET_INSTALL_COST',
      'OPTIMIZE_INSTALLS_WITHOUT_TARGET_INSTALL_COST',
      'OPTIMIZE_IN_APP_CONVERSIONS_TARGET_CONVERSION_COST',
      'OPTIMIZE_IN_APP_CONVERSIONS_TARGET_INSTALL_COST',
      'OPTIMIZE_IN_APP_CONVERSIONS_WITHOUT_TARGET_CPA',
      'OPTIMIZE_RETURN_ON_ADVERTISING_SPEND',
      'OPTIMIZE_TOTAL_VALUE_WITHOUT_TARGET_ROAS',
      'unknown',
    ],
    platformBreakdown: ['CONTENT', 'DISCOVER', 'GMAIL', 'SEARCH', 'SEARCH_PARTNERS', 'YOUTUBE'],
    country: [],
  },
  linkedin: {
    campaignObjective: ['brand_awareness', 'engagement', 'lead_generation', 'website_traffic'],
    optimizationGoal: [
      'CAP_COST_AND_MAXIMIZE_CLICKS',
      'ENHANCED_CONVERSION',
      'MAX_CLICK',
      'MAX_REACH',
      'NONE',
    ],
    platformBreakdown: ['linkedin', 'offsite'],
    country: [],
  },
  meta: {
    campaignObjective: [
      'app_promotion',
      'brand_awareness',
      'engagement',
      'lead_generation',
      'sales',
      'website_traffic',
    ],
    optimizationGoal: [
      'OPTIMIZE_FOR_CLICKS',
      'OPTIMIZE_FOR_CONVERSIONS',
      'OPTIMIZE_FOR_ENGAGEMENT',
      'OPTIMIZE_FOR_IMPRESSIONS',
      'OPTIMIZE_FOR_REVENUE',
      'VALUE',
      'unknown',
    ],
    platformBreakdown: [
      'audience_network',
      'facebook',
      'instagram',
      'messenger',
      'threads',
      'unknown',
    ],
    country: codes(`
      AE AF AG AL AM AO AR AS AT AU AW AZ BA BB BD BE BF BG BH BI BJ BM BN BO BQ BR BS BT BW
      BY BZ CA CD CG CH CI CK CL CM CN CO CR CV CW CY CZ DE DK DM DO DZ EC EE EG ES ET FI FJ
      FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM
      IN IQ IS IT JE JM JO JP KE KG KH KI KN KR KW KY KZ LA LB LC LK LR LS LT LU LV LY MA MD
      ME MG MH MK ML MM MN MP MR MT MU MV MW MX MY MZ NC NE NG NI NL NO NP NR NZ OM PA PE PF
      PG PH PK PL PR PS PT PW PY QA RO RS RW SA SB SC SE SG SI SK SL SN SO SR SS SV SX SY SZ
      TC TD TG TH TJ TL TM TN TO TR TT TW TZ UA UG US UY UZ VC VE VG VI VN VU WS XK YE ZA ZM
      ZW unknown
    `),
  },
  moloco: {
    campaignObjective: ['app_promotion'],
    optimizationGoal: ['OPTIMIZE_CPA_FOR_APP_UA', 'OPTIMIZE_ROAS_FOR_APP_UA'],
    platformBreakdown: codes(`
      ADX ADX_RTB APPLOVIN APPODEAL APS APX1 CHARTBOOST FIVE FYBER INMOBI IRONSOURCE MAGNITE
      MOBILITYWARE MOLOCO_SDK MOMENTO NAVER NIMBUS PUBMATIC SAMSUNG TABOOLA UNITY VUNGLE XIAOMI
    `),
    country: [],
  },
  snapchat: {
    campaignObjective: ['app_promotion', 'brand_awareness', 'conversions', 'sales'],
    optimizationGoal: [
      'APP_INSTALLS',
      'APP_PURCHASE',
      'APP_PURCHASE_VO',
      'APP_SIGNUP',
      'IMPRESSIONS',
      'LANDING_PAGE_VIEW',
      'PIXEL_PURCHASE',
    ],
    platformBreakdown: [],
    country: codes(`
      ae ar at au be bg bh br ca ch cl co cr cz de dk do dz ec eg es fi fr gr hk hr hu id ie il
      in iq it jo jp ke kw kz lb lt lu ma mc mx my ng nl no nz om pe ph pk pl pr pt qa ro rs sa
      se sg si sk th tn tr uk us uy za
    `),
  },
  tiktok: {
    campaignObjective: [
      'app_promotion',
      'conversions',
      'lead_generation',
      'reach',
      'video_views',
      'website_traffic',
    ],
    optimizationGoal: [
      'CLICK',
      'CONVERT',
      'ENGAGED_VIEW',
      'ENGAGED_VIEW_FIFTEEN',
      'INSTALL',
      'IN_APP_EVENT',
      'REACH',
      'TRAFFIC_LANDING_PAGE_VIEW',
      'VALUE',
    ],
    platformBreakdown: ['PLACEMENT_PANGLE', 'PLACEMENT_TIKTOK'],
    country: codes(`
      AE AR AT AU BE BG BH BO BR CA CH CL CO CR CY CZ DE DK DO EC EE EG ES FI FR GB GR HR HU
      ID IE IL IT JO JP KH KW KZ LV MX MY NG NL NO NZ PA PE PH PL PR PT PY QA RO SA SE SG SI
      TH TR US UY ZA
    `),
  },
};

export function fallbackValues(platform: string, dimension: string): readonly string[] {
  return FALLBACK_VALUES[platform]?.[dimension] ?? [];
}
